import React from "react";
import "./AdvisoryCouncilGrid.css";
import AdvisoryCouncilCard from "../AdvisoryCouncilCard/AdvisoryCouncilCard";
import { advisoryCouncilData } from "../advisoryCouncilData";

const AdvisoryCouncilGrid = () => {
  return (
    <section className="container advisory-grid-section mb-5 rounded-3">
      <div className="">
        <div className="row custom-width mx-auto">
          {advisoryCouncilData.slice(0, 3).map((item) => (
            <div key={item.id} className="col-lg-4 col-md-6 mb-4 px-4 d-flex">
              <AdvisoryCouncilCard item={item} />
            </div>
          ))}
        </div>

        <div className="row">
          {advisoryCouncilData.slice(3).map((item) => (
            <div key={item.id} className="col-lg-3 col-md-6 mb-4 px-4 d-flex">
              <AdvisoryCouncilCard item={item} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvisoryCouncilGrid;